import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { COUNTRY } from 'types/common';

const validateMobilePhoneNr = (phoneNr: string) => {
  const phoneNumberObject = parsePhoneNumberFromString(phoneNr, COUNTRY.NORWAY);
  return phoneNumberObject ? phoneNumberObject.isValid() : false;
};

export default validateMobilePhoneNr;
